import { render, staticRenderFns } from "./NotificationsPage.vue?vue&type=template&id=762f7444&"
import script from "./NotificationsPage.vue?vue&type=script&lang=ts&"
export * from "./NotificationsPage.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports